import { useApi, apiResolver } from "@/api/useApi";
import { useMemo } from "react";

type ConversationValidation = {
  conversationId: string;
  isValidated: boolean;
};

type GetConversationValidationRequest = {
  conversationId: string;
};

type UpdateConversationValidationRequest = {
  conversationId: string;
  isValidated: boolean;
};

export const useConversationValidationApi = () => {
  const { api } = useApi();

  return useMemo(
    () => ({
      getConversationValidation: ({ conversationId }: GetConversationValidationRequest) =>
        apiResolver<ConversationValidation>(
          api.get(`/platform/conversation-validation/conversations/${conversationId}`)
        ),
      updateConversationValidation: ({
        conversationId,
        isValidated,
      }: UpdateConversationValidationRequest) =>
        apiResolver<ConversationValidation>(
          api.put(`/platform/conversation-validation/conversations/${conversationId}`, { isValidated })
        ),
    }),
    [api]
  );
};
